import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'providers/GILT.provider';

import fromAnyToString from '../../utils/converters/fromAnyToString';

const AddRole = ({ onRoleNameChange, roleName }) => {
  const inputRef = useRef(null);
  const [name, setName] = useState(fromAnyToString(roleName));

  const { t } = useTranslation();

  const handleChange = useCallback(
    ({ target: { value } }) => {
      setName(value);
      onRoleNameChange(value);
    },
    [onRoleNameChange],
  );

  useEffect(() => void (inputRef.current && inputRef.current.focus()), []);

  return (
    <div data-bem="AddRole" className="content auto-height obs-add-role-container">
      <label htmlFor="RoleNameInput">
        <span data-bem="AddRole__label-text" className="obs-label">
          {t('composite.addRole.title')}
        </span>

        <input
          data-bem="AddRole__name"
          ref={inputRef}
          className="utl-full-width"
          type="text"
          placeholder={t('composite.addRole.inputPlaceholder')}
          id="RoleNameInput"
          value={name}
          onChange={handleChange}
          autoComplete="off"
        />
      </label>

      <div className="input-baseline" />
      <div className="input-prompt-hide">
        <div className="input-baseline" />
        <span data-bem="AddRole__message">{t('composite.addRole.errorMessage')}</span>
      </div>
    </div>
  );
};

export default AddRole;
